import { Input, InputGroup, InputProps, InputRightElement, IconButton } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { MouseEventHandler, ReactNode, useState } from 'react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { t } from '@/i18n';

export interface PasswordInputProps extends InputProps {
  label?: ReactNode;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({ label, ...props }, ref) => {
  const [show, setShow] = useState(false);

  const handleClick: MouseEventHandler<HTMLButtonElement> = () => {
    setShow(current => !current);
  };

  return (
    <InputGroup>
      <Input ref={ref} type={show ? 'text' : 'password'} {...props} />
      {label}
      <InputRightElement>
        <IconButton
          _hover={{
            backgroundColor: 'transparent',
          }}
          aria-label={t('components.password_input.password_input_aria_label')}
          variant='ghost'
          icon={show ? <ViewIcon width={5} height={5} color='gray' /> : <ViewOffIcon color='gray' width={5} height={5} />}
          width={8}
          height={8}
          onClick={handleClick}
        />
      </InputRightElement>
    </InputGroup>
  );
});
